import axios from "axios";

/**
 * Authenticated file download. All /api/v2/* download endpoints require a
 * Bearer token; a bare <a href> can't attach one. This fetches as a blob
 * and triggers a programmatic click instead.
 */
export async function downloadFile(url, filename) {
  const token = localStorage.getItem("token");
  const resp = await axios.get(url, {
    responseType: "blob",
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  const blobUrl = URL.createObjectURL(resp.data);
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = filename || "download";
  a.click();
  URL.revokeObjectURL(blobUrl);
}
